import { Component, OnInit, inject } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { DialogRef, DialogContentBase } from '@progress/kendo-angular-dialog';
import { GridDataResult } from '@progress/kendo-angular-grid';
import * as svgIcons from '@progress/kendo-svg-icons';

import { CustomerService } from '../customer.service';
import { GridService } from 'src/app/shared/grid.service';
import { DynamicEntityService } from 'src/app/module/servicentre/dynamic-entity.service';

@Component({
  selector: 'app-customer-popup',
  templateUrl: './customer-popup.component.html',
  styleUrls: ['./customer-popup.component.scss'],
})
export class CustomerPopupComponent extends DialogContentBase implements OnInit {
  public gridService = inject(GridService);
  private customerService = inject(CustomerService);
  private dynamicEntityService = inject(DynamicEntityService);

  public allIcons = svgIcons;

  title = '';
  button_cancel = '';
  type? = '';

  isLoading = false;
  gridView!: GridDataResult;
  id!: number;
  oDataStr = '';
  pageable = {
    pageSizes: this.gridService.pageSizes,
  };

  public state: State = {
    take: this.gridService.take,
    skip: 0,
  };

  constructor(public override dialog: DialogRef) {
    super(dialog);
  }

  ngOnInit(): void {
    this.refreshList();
  }

  cancel() {
    this.dialog.close(false);
  }

  select(e: any) {
    this.dialog.close(e.dataItem);
  }

  dataStateChange(state: State) {
    this.isLoading = true;
    this.gridService.setRowPerPages(state);
    this.state = state;
    this.refreshList();
  }

  refreshList() {
    // fetch customer
    this.isLoading = true;
    if (this.type == 'acomba') {
      // FETCH CLIENT FROM ACOMBA
      this.oDataStr = 'ClientsAcomba?$select=CuNumber,CuName,CuCareOf,CuPhoneNumber1,CuCity,CuAddress';
      this.dynamicEntityService.odataStr(this.state, this.oDataStr).subscribe((response) => {
        this.isLoading = false;
        this.gridView = {
          data: response,
          total: 3000,
        };
      });
    } else {
      // DEFAULT FETCH
      this.oDataStr = "$select=noClient,nomClient,nomPersonneContact,telephone1,ville,adresse&$filter=estActif eq 'OUI' and ctrlCloudBiLicenseId eq 1";
      this.customerService.odataStr(this.state, this.oDataStr).subscribe((response) => {
        this.isLoading = false;
        this.gridView = {
          data: response.value,
          total: response['@odata.count'],
        };
      });
    }
  }
}
